import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      {/* Rounded square outline — this is what gets drawn with strokeDashoffset */}
      <rect
        x="6"
        y="6"
        width="88"
        height="88"
        rx="14"
        ry="14"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Letter S — fades in as #B */}
      <g id="B">
        <text
          x="50"
          y="70"
          textAnchor="middle"
          fill="currentColor"
          fontFamily="Inter, sans-serif"
          fontWeight="700"
          fontSize="62">
          S
        </text>
      </g>
    </g>
  </svg>
);

export default IconLoader;
